import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import BrBrandHomeItem from '../../components/br/BrBrandHomeItem'
import BrBrandProdItem from '../../components/br/BrBrandProdItem'
import { setSelProdInfoAction } from '../../modules/common/prodModule';
import { useHistory, Link } from 'react-router-dom';
import {isMobileOnly} from 'react-device-detect';
import ProdItemSlider from '../../components/common/prod/ProdItemSlider';

const BrBrandAndPdListLiBlock = styled.li`
    margin-top: 60px;
    ${isMobileOnly&&`
        display:flex;
        justify-content: space-between;
    `};

    ::after {
        content: '';
        display: block;
        clear: both;
    }
`;

const BrBrandAndPdListUlBlock = styled.ul`
    width: 910px;
    float: left;
    ${isMobileOnly&&`
        display: flex;
        //overflow: scroll hidden;  
        overflow-x: scroll;
        overflow-y: hidden;    
    `};
`;

const SearchBrandAndPdListMBlock = styled.div`
    .mobile-pd-conatiner {
        overflow: scroll;
        overflow-y: hidden;
        display: flex;
        padding: 0 0 10px 0;
        //width: max-content;

        .pd-slider:last-child {
            padding-right: 4vw;
        }
        .pd-slider:first-child {
            margin-left: 4vw;
        }
    }
`;


const isNull = (value) => {
    return value !== null;
}

const BrBrandAndPdList = ({ brInfo }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const brandHomeInfo = brInfo._source;
    const brandProducts = brInfo.prods;

    const handleImgClick = (prodinfo) => {

        history.push('/prod?prodid=' + prodinfo._source.prdct_id)
    }

    const handleProdClick = (prodinfo) => {
        //console.log("prod = " + JSON.stringify(prodinfo))
        history.push('/prod?prodid=' + prodinfo.prdct_id)
    }

    if (brInfo === null) {
        return <BrBrandAndPdListLiBlock></BrBrandAndPdListLiBlock>
    }

    if (Object.keys(brInfo).includes('prods') === false || brInfo.prods === undefined) {
        return (
            <BrBrandAndPdListLiBlock>
                <BrBrandHomeItem img={brandHomeInfo.brnd_logo_url} brandInfo={brandHomeInfo.brnd_info_brief}
                    idHome={brandHomeInfo.id} brInfo={brInfo} reg_dtm={brInfo._source.reg_dtm}/>
            </BrBrandAndPdListLiBlock>
        );
    }

    return (
        isMobileOnly?
        <SearchBrandAndPdListMBlock className="clearfix margin_b-40">
            <BrBrandHomeItem img={brandHomeInfo.brnd_thumb_url} brandInfo={brandHomeInfo.brnd_info_brief}
                idHome={brandHomeInfo.id} brInfo={brInfo} brnd_han={brandHomeInfo.brnd_han} reg_dtm={brInfo._source.reg_dtm}/>
            
            <div style={{width:'100vw', marginLeft:'-4vw'}}>
                {
                    brandProducts === null ? '' :
                    <div className="mobile-pd-conatiner">
                        {
                        brandProducts.map((curprod) => {
                            return (
                                <ProdItemSlider key={curprod._source.prdct_id}
                                    img={curprod._source.repr_img}
                                    prodname={curprod._source.prdct_nm}
                                    sale_price={curprod._source.sale_price}
                                    prdct_price={curprod._source.prdct_price}
                                    brandname={curprod._source.brnd_han}
                                    isBrandShow={false}
                                    clickHandler={handleProdClick}
                                    brandid={curprod._source.brnd_id}
                                    prdct_id={curprod._source.prdct_id}
                                    prodinfo={curprod._source} />
                            )
                        })
                    }
                    </div>
                }
            </div>
        </SearchBrandAndPdListMBlock>
        :
        <BrBrandAndPdListLiBlock>
            <BrBrandHomeItem img={brandHomeInfo.brnd_logo_url} brandInfo={brandHomeInfo.brnd_info_brief}
                idHome={brandHomeInfo.id} brInfo={brInfo} reg_dtm={brInfo._source.reg_dtm}/>
            <BrBrandAndPdListUlBlock>
                {
                    brandProducts.map((prod) => {
                        return <BrBrandProdItem key={prod._source.prdct_id}
                            img={prod._source.repr_img}
                            prodname={prod._source.prdct_nm}
                            sale_price={prod._source.sale_price}
                            prdct_price={prod._source.prdct_price}
                            prdct_id={prod._source.prdct_id}
                            onClick={() => handleImgClick(prod)}
                        />
                    })
                }
            </BrBrandAndPdListUlBlock>
        </BrBrandAndPdListLiBlock>
    );

};

export default BrBrandAndPdList;
